import * as React from 'react';
import { Input, Col } from 'antd';
const InputGroup = Input.Group;
import SendCode from 'common/components/SendCode';

export default (config: any, decorator?: Function) => {
    return (
        <InputGroup>
            <Col span={14}>
                {decorator(
                    <Input placeholder={config.placeholder}/>
                )}
            </Col>
            <Col span={10}>
                <SendCode timeout={config.timeout}  call={config.call} size="large" disabled={config.disabled} lang={config.lang} formatFn={config.formatFn}
                          style={{ width: '100%', fontSize: 14 }}/>
            </Col>
        </InputGroup>
    );
};
